import React, { useState, createContext, useContext } from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import MenuLateral from './MenuLateral';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../modules/dashboard';
import ChatPage from '../modules/chat';
import PainelDetalhes from '../modules/painelatendimento/PainelDetalhes';
import { carregarModulosDisponiveis } from '../utils/carregarModulos';
import { SearchProvider } from '../contexts/SearchContext';

// Contexto para compartilhar a largura do drawer
const DrawerWidthContext = createContext();

export const useDrawerWidth = () => {
  const context = useContext(DrawerWidthContext);
  if (!context) {
    throw new Error('useDrawerWidth deve ser usado dentro de DrawerWidthProvider');
  }
  return context;
};

function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [rotasModulos, setRotasModulos] = useState([]);
  const [drawerWidth, setDrawerWidth] = useState(360); // Largura padrão

  // Carrega largura salva do drawer
  React.useEffect(() => {
    const savedWidth = localStorage.getItem('drawerWidth');
    if (savedWidth) {
      const width = parseInt(savedWidth);
      if (width >= 240 && width <= 500) {
        setDrawerWidth(width);
      }
    }
  }, []);

  React.useEffect(() => {
    const stored = localStorage.getItem("usuario");

    if (stored) {
      try {
        const usuarioStored = JSON.parse(stored);

        // Carrega os módulos apenas uma vez com timeout
        const timeoutId = setTimeout(() => {
          carregarModulosDisponiveis(usuarioStored)
            .then(rotas => {
              console.log('Rotas carregadas no MainLayout:', rotas.length);
              setRotasModulos(rotas);
            })
            .catch(err => {
              setRotasModulos([]);
            });
        }, 100); // Pequeno delay para estabilizar

        return () => clearTimeout(timeoutId);
      } catch (error) {
        setRotasModulos([]);
      }
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <SearchProvider>
      <DrawerWidthContext.Provider value={{ drawerWidth, setDrawerWidth }}>
        <Box sx={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
          <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
          <MenuLateral open={sidebarOpen} rotasModulos={rotasModulos} />
          <Box
            component="main"
            sx={{
              p: 0, // ✅ Remover padding que pode causar espaços
              backgroundColor: (theme) => theme.palette.background.default,
              transition: (theme) => theme.transitions.create('left', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              // ✅ Posicionamento dinâmico baseado na largura do drawer
              position: 'absolute',
              top: '64px', // ✅ Manter apenas o espaço necessário para o header
              left: sidebarOpen ? `${drawerWidth}px` : '0px',
              right: 0,
              bottom: 0,
              overflowY: 'auto',
              // ✅ Garantir que não haja margens extras
              margin: 0,
              // ✅ Para o dashboard específico, remover espaços
              '& .dashboard-container': {
                margin: 0,
                padding: 0
              }
            }}
          >
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/chat" element={<ChatPage />} />
              {/* Rota estática para painel de detalhes */}
              <Route path="/painelatendimento/detalhes" element={<PainelDetalhes />} />
              {/* Rotas dinâmicas dos módulos */}
              {Array.isArray(rotasModulos) && rotasModulos.map((r, i) => (
                <Route
                  key={i}
                  path={r.path}
                  element={<r.element />}
                />
              ))}
              <Route path="*" element={<Dashboard />} />
            </Routes>
          </Box>
        </Box>
      </DrawerWidthContext.Provider>
    </SearchProvider>
  );
}

export default MainLayout; 